module.exports = __webpack_public_path__ + "static/media/Daniele_respiracao.7f5414bc.jpg";